export default {
    namespaced: true,
    state() {
        return {
            uncollected: 0,
            pageOrientation: 0,
            expanded: true,
        };
    },
    getters: {
        uncollected: state => state.uncollected,
        pageOrientation: state => state.pageOrientation,
        expanded: state => state.expanded,
    },
    mutations: {
        setUncollected(state, uncollected) {
            state.uncollected = uncollected;
        },
        setPageOrientation(state, orientation) {
            state.pageOrientation = orientation;
        },
        setExpanded(state, expanded) {
            state.expanded = expanded;
        },
    },
    actions: {
        async changeUncollected({ commit }, value) {
            commit('setUncollected', value);
        },
        async changePageOrientation({ commit }, value) {
            commit('setPageOrientation', value);
        },
        async changeExpanded({ commit }, value) {
            commit('setExpanded', value);
        },
    },
};
